import React from 'react'
import Image from 'next/image'
import { PHONE_CALL_URL, RIGHT_ARROW_URL } from '@constants/contactUs.constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS } from '@configs/contactus.config'
import styles from './styles.module.scss'

const handlePhoneTapEvent = async cta => {
  await trackEvent(CONTACT_US_EVENTS.CALL_LIST_CLICKED.eventName, {
    ...CONTACT_US_EVENTS.CALL_LIST_CLICKED.eventProps,
    platform: getDevicePlatform(),
    lob: cta.Title,
    phone: cta.Link,
  })
}
const handleEmailTapEvent = async cta => {
  await trackEvent(CONTACT_US_EVENTS.EMAIL_LIST_CLICKED.eventName, {
    ...CONTACT_US_EVENTS.EMAIL_LIST_CLICKED.eventProps,
    platform: getDevicePlatform(),
    lob: cta.Title,
    email: cta.Link,
  })
}
const renderPhoneCTA = (cta, isMobile, isLast = false) => {
  const iconSize = isLast ? 32 : 16
  const iconContainerClass = isLast ? styles.ctaIconContainerNoPadding : styles.ctaIconContainer

  return isMobile ? (
    <a
      href={`tel:${cta.Link}`}
      className={styles.phoneCardLinkMobile}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={() => handlePhoneTapEvent(cta)}>
      <div>
        {cta.modal_cta_icons && cta.modal_cta_icons.length > 0 && (
          <div className={styles.cardIcon}>
            {cta.modal_cta_icons.map((icon, iconIdx) => (
              <div key={iconIdx} className={iconContainerClass} style={{ zIndex: iconIdx + 1 }}>
                <Image
                  src={icon.url}
                  alt={`icon-${iconIdx}`}
                  width={iconSize}
                  height={iconSize}
                  className={styles.ctaIcon}
                />
              </div>
            ))}
          </div>
        )}
        <div className={styles.cardText}>{cta.Title}</div>
      </div>
      <div className={styles.cardActionDetails}>
        <div className={styles.cardActionTextWrapper}>
          <span className={styles.cardLinkText}>{cta.Link}</span>
        </div>
        <Image src={PHONE_CALL_URL} alt="phone-call" width={16} height={16} />
      </div>
    </a>
  ) : (
    <>
      <div>
        {cta.modal_cta_icons && cta.modal_cta_icons.length > 0 && (
          <div className={styles.cardIcon}>
            {cta.modal_cta_icons.map((icon, iconIdx) => (
              <div key={iconIdx} className={iconContainerClass} style={{ zIndex: iconIdx + 1 }}>
                <Image
                  src={icon.url}
                  alt={`icon-${iconIdx}`}
                  width={iconSize}
                  height={iconSize}
                  className={styles.ctaIcon}
                />
              </div>
            ))}
          </div>
        )}
        <div className={styles.cardText}>{cta.Title}</div>
      </div>
      <div className={styles.cardLinkDesktop}>
        <span className={styles.cardLinkText}>{cta.Link}</span>
      </div>
    </>
  )
}

const renderEmailCTA = (cta, isMobile, _isLast = false) => (
  <a
    href={`mailto:${cta.Link}`}
    className={isMobile ? styles.emailCardLinkMobile : styles.emailCardLink}
    rel="noopener noreferrer"
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onClick={() => handleEmailTapEvent(cta)}>
    {isMobile ? (
      <>
        <div className={styles.emailCardTopRow}>
          {cta.modal_cta_icons && cta.modal_cta_icons.length > 0 && (
            <div className={styles.emailCardIcon}>
              {cta.modal_cta_icons.map((icon, iconIdx) => (
                <div key={iconIdx} className={styles.ctaIconContainer} style={{ zIndex: iconIdx + 1 }}>
                  <Image src={icon.url} alt={`icon-${iconIdx}`} width={16} height={16} className={styles.ctaIcon} />
                </div>
              ))}
            </div>
          )}
          <div className={styles.cardText}>{cta.Title}</div>
        </div>
        <div className={styles.emailCardBottomRow}>
          <span className={styles.emailLink}>{cta.Link}</span>
          <Image src={RIGHT_ARROW_URL} alt="right-arrow" width={24} height={24} className={styles.emailArrow} />
        </div>
      </>
    ) : (
      <>
        <div>
          {cta.modal_cta_icons && cta.modal_cta_icons.length > 0 && (
            <div className={styles.cardIcon}>
              {cta.modal_cta_icons.map((icon, iconIdx) => (
                <div key={iconIdx} className={styles.ctaIconContainer} style={{ zIndex: iconIdx + 1 }}>
                  <Image src={icon.url} alt={`icon-${iconIdx}`} width={16} height={16} className={styles.ctaIcon} />
                </div>
              ))}
            </div>
          )}
          <div className={styles.cardText}>{cta.Title}</div>
        </div>
        <div className={styles.cardLinkDesktop}>
          <span className={styles.cardLink}>{cta.Link}</span>
        </div>
      </>
    )}
  </a>
)

export const ctaRenderers = {
  Phone: renderPhoneCTA,
  Email: renderEmailCTA,
}
